var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",style:(!_vm.$kmsTheme ? null : _vm.$kmsTheme.styles.footer)},[_c('p',{staticClass:"footerText"},[_vm._v(_vm._s(_vm.footer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }